import React, { useEffect, useState } from "react";
import "../assets/css/PartnerGet.css";
import centerImg from "../assets/home-page-imgs/onboard.jpg";

const features = [
  {
    title: "Onboarding & Setup Support",
    desc: "End-to-end assistance to help you launch and operate your franchise smoothly."
  },
  {
    title: "Ongoing Training Access",
    desc: "Continuous online & offline training to stay ahead of market trends."
  },
  {
    title: "Marketing & Lead Generation",
    desc: "National & regional campaigns with structured lead flow support."
  },
  {
    title: "Digital Management Tools",
    desc: "CRM, client tracking, documentation & reporting systems."
  }
];

const PartnerGet = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;

    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % features.length);
    }, 2500);

    return () => clearInterval(interval);
  }, [paused]);

  return (
    <section className="partner-get-section" id="franchise">
      <div className="partner-get-container">

        <h2 className="partner-get-title">
          Franchise <span>Success</span>, Built In 
        </h2>
        <p className="partner-get-subtitle">
          A complete ecosystem designed to help you grow, scale, and succeed in real estate
        </p>

        <div className="partner-get-layout">

          {/* LEFT */}
          <div className="partner-get-column">
            {[0, 1].map((i) => (
              <div
                key={i}
                className={`partner-get-card ${activeIndex === i ? "active" : ""}`}
                onMouseEnter={() => setPaused(true)}
                onMouseLeave={() => setPaused(false)}
              >
                <h4>{features[i].title}</h4>
                <p>{features[i].desc}</p>
              </div>
            ))}
          </div>

          {/* CENTER */}
          <div className="partner-get-center">
            <img src={centerImg} alt="Samriddhi Gurukul Platform" />
          </div>

          {/* RIGHT */}
          <div className="partner-get-column">
            {[2, 3].map((i) => (
              <div
                key={i}
                className={`partner-get-card ${activeIndex === i ? "active" : ""}`}
                onMouseEnter={() => setPaused(true)}
                onMouseLeave={() => setPaused(false)}
              >
                <h4>{features[i].title}</h4>
                <p>{features[i].desc}</p>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default PartnerGet;
